export enum ClientApiType {
    ECOMMERCE = 'ecommerce',
    LOYALTY = 'loyalty',
}

export enum EnvVarKeys {
    CONTENTFUL_SPACE_ID = 'CONTENTFUL_SPACE_ID',
    CONTENTFUL_DELIVERY_ACCESS_TOKEN = 'CONTENTFUL_DELIVERY_ACCESS_TOKEN',
    CONTENTFUL_PREVIEW_ACCESS_TOKEN = 'CONTENTFUL_PREVIEW_ACCESS_TOKEN',
    CONTENTFUL_ENVIRONMENT = 'CONTENTFUL_ENVIRONMENT',
    CONTENTFUL_PREVIEW_MODE = 'CONTENTFUL_PREVIEW_MODE',
    LOYALTY_CONTENTFUL_DELIVERY_ACCESS_TOKEN = 'LOYALTY_CONTENTFUL_DELIVERY_ACCESS_TOKEN',
    LOYALTY_CONTENTFUL_ENVIRONMENT = 'LOYALTY_CONTENTFUL_ENVIRONMENT',
    LOYALTY_CONTENTFUL_PREVIEW_ACCESS_TOKEN = 'LOYALTY_CONTENTFUL_PREVIEW_ACCESS_TOKEN',
    LOYALTY_CONTENTFUL_PREVIEW_MODE = 'LOYALTY_CONTENTFUL_PREVIEW_MODE',
    LOYALTY_CONTENTFUL_SPACE_ID = 'LOYALTY_CONTENTFUL_SPACE_ID',
}

export type ClientParameter = {
    envVarKey: EnvVarKeys;
    value?: string;
};

export type ClientParameters = {
    spaceId: ClientParameter;
    deliveryAccessToken: ClientParameter;
    previewAccessToken: ClientParameter;
    environmentId: ClientParameter;
    previewMode: ClientParameter;
};
